// this component is just an empty slot to be able to create groups with gaps
export const EmptySlot = () => <div />;
